import { useRef, useState } from 'react';
import {
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    Popover,
    Stack,
} from '@mui/material';

import { GameElementPicker } from '../../../shared/GameElementPicker/GameElementPicker';

import { GameElementDto } from '../../../hooks/gameElements';

import { isGiftWrap } from './giftFormUtils';

interface Props {
    gameElements: Map<string, GameElementDto>;
    wrapperGameElementId?: string;
    onChange: (wrapperGameElementId: string) => void;
}

export const WrappingField = ({
    gameElements,
    wrapperGameElementId,
    onChange,
}: Props) => {
    const buttonRef = useRef<HTMLButtonElement>(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [showOnlyWrapping, setShowOnlyWrapping] = useState(true);

    return (
        <Stack direction="row" spacing={2}>
            <GameElementPicker
                sx={{ flex: 1 }}
                label="Wrapping"
                value={
                    wrapperGameElementId
                        ? gameElements.get(wrapperGameElementId)
                        : undefined
                }
                size="small"
                disableClearable
                onChange={(gameElement) => {
                    if (gameElement) {
                        onChange(gameElement.id);
                    }
                }}
                gameElementFilter={showOnlyWrapping ? isGiftWrap : undefined}
            />
            <Button
                ref={buttonRef}
                variant="text"
                onClick={() => setMenuOpen((isOpen) => !isOpen)}
            >
                Wrapping options
            </Button>
            <Popover
                open={menuOpen}
                anchorEl={() => buttonRef.current}
                onClose={() => setMenuOpen(false)}
            >
                <Box sx={{ padding: 2 }}>
                    <FormControlLabel
                        control={<Checkbox />}
                        checked={showOnlyWrapping}
                        onChange={(_, checked) => setShowOnlyWrapping(checked)}
                        label="Show only gift wrappings"
                    />
                </Box>
            </Popover>
        </Stack>
    );
};
